import Axios, { AxiosInstance } from 'axios';
import { HttpComm } from './HttpComm';
import { API_URL } from '../../config';

const baseURL = API_URL;

const instance: AxiosInstance = Axios.create({
  baseURL: baseURL,
  timeout: 60000
});

export const ApiComm = new HttpComm(instance);
